import React, { FC } from 'react';
import cn from 'classnames';
require("./TextInput-Counter.css");
var styles = {
  "Root": "TextInput-Counter-module-Root_2Ef"
};
export const TextInputCounter = ({
  current = 0,
  max,
  className
}) => /*#__PURE__*/React.createElement("div", {
  className: cn(styles.Root, className)
}, `${current}${max ? `/${max}` : ''}`);